import React from 'react';

import s from './style.module.css';
import { PriceTableProps, MemberShipProps } from '../../../props';
import { priceFormat, totalBudgetFormat, calcTotalBudgetWithCommission } from '@Util/util';
import MemberSwitch from '@Pages/Detail/components/member_switch/view';
import PriceVersionNote from '@Pages/Detail/components/price_version_note/view';

const BuyingPriceTable = (props: MemberShipProps) => {
    const [membership, setMemberShip] = React.useState(props.memberships[0]);
    return (
        <div className={s.head_2_body}>
            <MemberSwitch
                onChange={(v) => setMemberShip(v)}
                memberships={props.memberships}
                isDisplayInitialOffering={true}
                currentMembership={membership}
            />
            <PriceTable membership={membership} isJpy={props.isJpy} />
            <PriceVersionNote memberships={[membership]} />
        </div>
    );
};

const PriceTable = (props: PriceTableProps) => {
    const membership = props.membership;
    const displayNumberOfSellingOffers = !membership.isInitialOffering || membership.numberOfSellingOffers;
    const priceUnit = props.isJpy ? '万円' : 'THB';
    const totalBudget = membership.isInitialOffering
        ? membership.totalBudget
        : calcTotalBudgetWithCommission(membership.totalBudget, membership.sellingPrice);

    return (
        <table className={s.price_table}>
            <tbody>
                <tr>
                    <th>
                        {membership.isInitialOffering ? (
                            <>
                                入会金
                                <span className={s.price_table_supplement}>
                                    {displayNumberOfSellingOffers ? '（定員）' : ''}
                                </span>
                            </>
                        ) : (
                            <>
                                売希望最安値<span className={s.price_table_supplement}>（件数）</span>
                            </>
                        )}
                    </th>
                    <td>
                        {membership.isAsk ? <span>ご相談</span> : priceFormat(membership.sellingPrice, priceUnit)}
                        {displayNumberOfSellingOffers ? (
                            <span className={s.price_table_supplement}>
                                （{membership.numberOfSellingOffers}
                                {membership.isInitialOffering ? '名' : '件'}）
                            </span>
                        ) : (
                            ''
                        )}
                    </td>
                </tr>
                <tr>
                    <th>名義書換料</th>
                    <td>{priceFormat(membership.registrationFee, priceUnit)}</td>
                </tr>
                <tr>
                    <th>入会預託金</th>
                    <td>{priceFormat(membership.deposit, priceUnit)}</td>
                </tr>
                <tr>
                    <th>年会費</th>
                    <td>{priceFormat(membership.annualFee, props.isJpy ? '円' : 'THB')}</td>
                </tr>
                <tr>
                    <th>購入総額概算</th>
                    <td>
                        {membership.isAsk
                            ? 'ご相談'
                            : `${totalBudgetFormat(
                                  totalBudget,
                                  membership.numberOfSellingOffers,
                                  membership.isInitialOffering
                              )}${priceUnit}`}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default BuyingPriceTable;
